import { Routes } from '@angular/router';
import { Dashboard } from './pages/dashboard/dashboard';
import { Provider } from './pages/provider/provider';
import { Providers } from './pages/providers/providers';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'tableau-de-bord',
        pathMatch: 'full'
    },
    {
        path: 'tableau-de-bord',
        component: Dashboard,
        title: 'Tableau de bord',
    },
    {
        path: 'prestataire/:id/detail',
        component: Provider,
        title: 'Détail du prestataire',
    },
    {
        path: 'prestataires',
        component: Providers,
        title: 'Liste des prestataires',
    },
];
